import { Controller } from "stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["datepicker"]

  connect() {
    const options = {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      minuteIncrement: this.element.dataset.fullHour === "false" ? 1 : 60,
      hourIncrement: 1,
      defaultMinute: 0,
    }

    flatpickr(this.datepickerTarget, options)
  }

  clear(event) {
    event.preventDefault()

    if (!this.hasDatepickerTarget) return

    this.datepickerTarget.value = ""
    this.datepickerTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.datepickerTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
